import CircularProgressBar, { CircularProgressBarProps } from '../progress/CircularProgressBar';

export default function LoadingIndicator(props: CircularProgressBarProps) {
  return <CircularProgressBar variant="indeterminate" {...props} />;
}
